module.exports = __webpack_public_path__ + "static/media/App-store-badge.1b659262.svg";